import { defineStore } from "pinia";

import { ACTION_SIGNUP_CREATE, ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
import { SignupModel } from "@core/models";

export const useSignupStore = defineStore("signup", {
  // convert to a function
  state: () => ({
    signup: undefined,
  }),
  getters: {
    [GETTER_SIGNUP_GET]: (state) => new SignupModel(state.signup),
  },
  actions: {
    [ACTION_SIGNUP_CREATE](signup) {
      this.signup = signup;
    },
    [ACTION_SIGNUP_UPDATE](attributes) {
      if (attributes) {
        this.signup = { ...this.signup, ...attributes };
      }
    },
    // easily reset state using `$reset`
    clearSignupStore() {
      this.$reset();
    },
  },
});
